export class UtilityRunParameter<T> {
    constructor(code: string, value:T) {
        this.code = code;
        this.value = value;
    }

    code: string;
    value: T;
}